import { useLocale } from "../contexts/LocaleContext";
function RichText({ text }: { text: string }) {
  const parts = text.split(/(\*\*.*?\*\*|\[.*?\]\(.*?\))/g);
  return (
    <>
      {parts.map((part, index) => {
        if (part.startsWith("**") && part.endsWith("**")) {
          return <strong key={index}>{part.slice(2, -2)}</strong>;
        }
        const link = part.match(/^\[(.*?)\]\((.*?)\)$/);
        if (link) {
          return (
            <a key={index} href={link[2]} target="_blank" rel="noreferrer">
              {link[1]}
            </a>
          );
        }
        return part;
      })}
    </>
  );
}

function P({ k }: { k: string }) {
  const { t } = useLocale();
  return <p><RichText text={t(k)} /></p>;
}

function LI({ k }: { k: string }) {
  const { t } = useLocale();
  return <li><RichText text={t(k)} /></li>;
}

export function AGBPage() {
  const { t } = useLocale();

  return (
    <section className="wrapper agb-page">
      <h1>{t("legal.agb.title")}</h1>
      <P k="legal.agb.intro" />

      <section className="agb-section">
        <h2>1. <RichText text={t("legal.agb.s1Title")} /></h2>
        <P k="legal.agb.s1P1" />
        <P k="legal.agb.s1P2" />
      </section>

      <section className="agb-section">
        <h2>2. <RichText text={t("legal.agb.s2Title")} /></h2>
        <P k="legal.agb.s2P1" />
        <P k="legal.agb.s2P2" />
        <P k="legal.agb.s2P3" />
        <ul>
          <LI k="legal.agb.s2B1" />
          <LI k="legal.agb.s2B2" />
          <LI k="legal.agb.s2B3" />
          <LI k="legal.agb.s2B4" />
        </ul>
      </section>

      <section className="agb-section">
        <h2>3. <RichText text={t("legal.agb.s3Title")} /></h2>
        <P k="legal.agb.s3P1" />
        <P k="legal.agb.s3P2" />
        <P k="legal.agb.s3P3" />
        <ul>
          <LI k="legal.agb.s3B1" />
          <LI k="legal.agb.s3B2" />
          <LI k="legal.agb.s3B3" />
        </ul>
        <div className="agb-subsection">
          <P k="legal.agb.s3Sub1P1" />
          <P k="legal.agb.s3Sub1P2" />
          <P k="legal.agb.s3Sub1P3" />
        </div>
      </section>

      <section className="agb-section">
        <h2>4. <RichText text={t("legal.agb.s4Title")} /></h2>
        <P k="legal.agb.s4P1" />
        <P k="legal.agb.s4P2" />
        <P k="legal.agb.s4P3" />
      </section>

      <section className="agb-section">
        <h2>5. <RichText text={t("legal.agb.s5Title")} /></h2>
        <P k="legal.agb.s5P1" />
        <P k="legal.agb.s5P2" />
        <P k="legal.agb.s5P3" />
        <P k="legal.agb.s5P4" />
        <P k="legal.agb.s5P5" />
        <P k="legal.agb.s5P6" />
        <P k="legal.agb.s5P7" />
      </section>

      <section className="agb-section">
        <h2>6. <RichText text={t("legal.agb.s6Title")} /></h2>
        <div className="agb-subsection">
          <h3><RichText text={t("legal.agb.s6Sub1Title")} /></h3>
          <P k="legal.agb.s6Sub1P1" />
          <ul>
            <LI k="legal.agb.s6Sub1B1" />
            <LI k="legal.agb.s6Sub1B2" />
            <LI k="legal.agb.s6Sub1B3" />
            <LI k="legal.agb.s6Sub1B4" />
          </ul>
        </div>
        <div className="agb-subsection">
          <h3><RichText text={t("legal.agb.s6Sub2Title")} /></h3>
          <P k="legal.agb.s6Sub2P1" />
          <ul>
            <LI k="legal.agb.s6Sub2B1" />
            <LI k="legal.agb.s6Sub2B2" />
            <LI k="legal.agb.s6Sub2B3" />
            <LI k="legal.agb.s6Sub2B4" />
            <LI k="legal.agb.s6Sub2B5" />
            <LI k="legal.agb.s6Sub2B6" />
            <LI k="legal.agb.s6Sub2B7" />
            <LI k="legal.agb.s6Sub2B8" />
            <LI k="legal.agb.s6Sub2B9" />
            <LI k="legal.agb.s6Sub2B10" />
            <LI k="legal.agb.s6Sub2B11" />
            <LI k="legal.agb.s6Sub2B12" />
          </ul>
        </div>
        <div className="agb-subsection">
          <h3><RichText text={t("legal.agb.s6Sub3Title")} /></h3>
          <P k="legal.agb.s6Sub3P1" />
          <P k="legal.agb.s6Sub3P2" />
        </div>
        <div className="agb-subsection">
          <h3><RichText text={t("legal.agb.s6Sub4Title")} /></h3>
          <P k="legal.agb.s6Sub4P1" />
          <ul>
            <LI k="legal.agb.s6Sub4B1" />
            <LI k="legal.agb.s6Sub4B2" />
            <LI k="legal.agb.s6Sub4B3" />
            <LI k="legal.agb.s6Sub4B4" />
            <LI k="legal.agb.s6Sub4B5" />
          </ul>
          <P k="legal.agb.s6Sub4A1" />
        </div>
      </section>

      <section className="agb-section">
        <h2>7. <RichText text={t("legal.agb.s7Title")} /></h2>
        <P k="legal.agb.s7P1" />
        <P k="legal.agb.s7P2" />
      </section>

      <section className="agb-section">
        <h2>8. <RichText text={t("legal.agb.s8Title")} /></h2>
        <P k="legal.agb.s8P1" />
        <ul>
          <LI k="legal.agb.s8B1" />
          <LI k="legal.agb.s8B2" />
          <LI k="legal.agb.s8B3" />
          <LI k="legal.agb.s8B4" />
          <LI k="legal.agb.s8B5" />
          <LI k="legal.agb.s8B6" />
          <LI k="legal.agb.s8B7" />
        </ul>
        <div className="agb-subsection">
          <P k="legal.agb.s8Sub1P1" />
        </div>
      </section>

      <section className="agb-section">
        <h2>9. <RichText text={t("legal.agb.s9Title")} /></h2>
        <P k="legal.agb.s9P1" />
        <ul>
          <LI k="legal.agb.s9B1" />
          <LI k="legal.agb.s9B2" />
          <LI k="legal.agb.s9B3" />
          <LI k="legal.agb.s9B4" />
          <LI k="legal.agb.s9B5" />
          <LI k="legal.agb.s9B6" />
          <LI k="legal.agb.s9B7" />
          <LI k="legal.agb.s9B8" />
          <LI k="legal.agb.s9B9" />
        </ul>
        <div className="agb-subsection">
          <P k="legal.agb.s9Sub1P1" />
        </div>
      </section>

      <section className="agb-section">
        <h2>10. <RichText text={t("legal.agb.s10Title")} /></h2>
        <div className="agb-subsection">
          <h3><RichText text={t("legal.agb.s10Sub1Title")} /></h3>
          <P k="legal.agb.s10Sub1P1" />
          <ul>
            <LI k="legal.agb.s10Sub1B1" />
            <LI k="legal.agb.s10Sub1B2" />
          </ul>
        </div>
        <div className="agb-subsection">
          <h3><RichText text={t("legal.agb.s10Sub2Title")} /></h3>
          <P k="legal.agb.s10Sub2P1" />
          <ul>
            <LI k="legal.agb.s10Sub2B1" />
            <LI k="legal.agb.s10Sub2B2" />
            <LI k="legal.agb.s10Sub2B3" />
          </ul>
        </div>
        <div className="agb-subsection">
          <h3><RichText text={t("legal.agb.s10Sub3Title")} /></h3>
          <P k="legal.agb.s10Sub3P1" />
          <ul>
            <LI k="legal.agb.s10Sub3B1" />
            <LI k="legal.agb.s10Sub3B2" />
            <LI k="legal.agb.s10Sub3B3" />
            <LI k="legal.agb.s10Sub3B4" />
            <LI k="legal.agb.s10Sub3B5" />
          </ul>
        </div>
      </section>

      <section className="agb-section">
        <h2>11. <RichText text={t("legal.agb.s11Title")} /></h2>
        <P k="legal.agb.s11P1" />
        <P k="legal.agb.s11P2" />
      </section>

      <section className="agb-section">
        <h2>12. <RichText text={t("legal.agb.s12Title")} /></h2>
        <P k="legal.agb.s12P1" />
      </section>

      <section className="agb-section">
        <h2>13. <RichText text={t("legal.agb.s13Title")} /></h2>
        <P k="legal.agb.s13P1" />
      </section>

      <section className="agb-section">
        <h2>14. <RichText text={t("legal.agb.s14Title")} /></h2>
        <P k="legal.agb.s14P1" />
        <ul>
          <LI k="legal.agb.s14B1" />
          <LI k="legal.agb.s14B2" />
          <LI k="legal.agb.s14B3" />
        </ul>
        <div className="agb-subsection">
          <P k="legal.agb.s14Sub1P1" />
        </div>
      </section>

      <section className="agb-section">
        <h2>15. <RichText text={t("legal.agb.s15Title")} /></h2>
        <P k="legal.agb.s15P1" />
        <P k="legal.agb.s15P2" />
      </section>

      <section className="agb-section">
        <h2>16. <RichText text={t("legal.agb.s16Title")} /></h2>
        <P k="legal.agb.s16P1" />
        <P k="legal.agb.s16P2" />
        <ul>
          <LI k="legal.agb.s16B1" />
          <LI k="legal.agb.s16B2" />
          <LI k="legal.agb.s16B3" />
          <LI k="legal.agb.s16B4" />
          <LI k="legal.agb.s16B5" />
        </ul>
      </section>

      <section className="agb-section">
        <h2>17. <RichText text={t("legal.agb.s17Title")} /></h2>
        <P k="legal.agb.s17P1" />
        <P k="legal.agb.s17P2" />
      </section>

      <section className="agb-section">
        <h2>18. <RichText text={t("legal.agb.s18Title")} /></h2>
        <P k="legal.agb.s18P1" />
        <P k="legal.agb.s18P2" />
      </section>

      <section className="agb-section">
        <h2>19. <RichText text={t("legal.agb.s19Title")} /></h2>
        <P k="legal.agb.s19P1" />
        <P k="legal.agb.s19P2" />
        <P k="legal.agb.s19P3" />
        <P k="legal.agb.s19P4" />
      </section>

    </section>
  );
}
